import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "privacy-body ion-padding" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "privacy-footer" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "privacy-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.goBack }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.arrowBackOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Удаление аккаунта", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background privacy-content",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "privacy-intro" }, " На этой странице описано, как пользователь мобильного приложения «Лига тренеров» (com.growapp.ligaapp) может запросить удаление аккаунта и связанных с ним персональных данных. ", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("h2", null, "1. Удаление в приложении", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("p", null, " Если у вас установлено приложение и вы можете войти в аккаунт: ", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("ol", { class: "steps-list" }, [
              _createElementVNode("li", null, "Откройте приложение «Лига тренеров» и войдите в аккаунт."),
              _createElementVNode("li", null, [
                _createTextVNode("Перейдите в раздел "),
                _createElementVNode("strong", null, "«Личный кабинет»"),
                _createTextVNode(" (меню приложения).")
              ]),
              _createElementVNode("li", null, [
                _createTextVNode("Нажмите кнопку "),
                _createElementVNode("strong", null, "«Удалить аккаунт»"),
                _createTextVNode(" и подтвердите действие.")
              ])
            ], -1)),
            _cache[11] || (_cache[11] = _createElementVNode("p", null, " После подтверждения аккаунт и связанные с ним данные в приложении будут удалены без возможности восстановления. ", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("h2", null, "2. Запрос по электронной почте", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("p", null, " Если приложение удалено или вы не можете войти в аккаунт, направьте запрос на удаление на адрес: ", -1)),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                href: 'mailto:' + _ctx.contactEmail + '?subject=' + encodeURIComponent(_ctx.mailSubject),
                class: "privacy-link"
              }, _toDisplayString(_ctx.contactEmail), 9, _hoisted_2)
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("p", null, "Укажите в письме:", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("ul", { class: "steps-list" }, [
              _createElementVNode("li", null, "адрес электронной почты, привязанный к аккаунту;"),
              _createElementVNode("li", null, "логин (если помните);"),
              _createElementVNode("li", null, "текст запроса на удаление аккаунта и персональных данных.")
            ], -1)),
            _cache[16] || (_cache[16] = _createElementVNode("p", null, " Мы обработаем запрос в разумный срок и сообщим о результате на указанный e-mail. ", -1)),
            _cache[17] || (_cache[17] = _createElementVNode("h2", null, "3. Какие данные удаляются", -1)),
            _cache[18] || (_cache[18] = _createElementVNode("p", null, "При удалении аккаунта удаляются или обезличиваются, в частности:", -1)),
            _cache[19] || (_cache[19] = _createElementVNode("ul", { class: "steps-list" }, [
              _createElementVNode("li", null, "учётная запись (логин, e-mail, имя и фамилия, номер телефона);"),
              _createElementVNode("li", null, "данные профиля и настройки в приложении;"),
              _createElementVNode("li", null, "сессии авторизации на устройствах;"),
              _createElementVNode("li", null, "данные о прогрессе и активности, привязанные к аккаунту в приложении.")
            ], -1)),
            _cache[20] || (_cache[20] = _createElementVNode("h2", null, "4. Какие данные могут сохраняться", -1)),
            _cache[21] || (_cache[21] = _createElementVNode("p", null, " Отдельные сведения могут храниться дольше, если это требуется законом или необходимо для исполнения обязательств (например, документы и записи о платежах за платные услуги — в сроки, установленные законодательством РФ). Такие данные не используются для иных целей. ", -1)),
            _cache[22] || (_cache[22] = _createElementVNode("h2", null, "5. Дополнительно", -1)),
            _createElementVNode("p", null, [
              _cache[2] || (_cache[2] = _createTextVNode(" С политикой обработки персональных данных можно ознакомиться на странице ", -1)),
              _createVNode(_component_router_link, {
                to: "/privacy-policy",
                class: "privacy-link"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Политика конфиденциальности", -1)
                ]))]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createTextVNode(". ", -1))
            ]),
            _createElementVNode("p", _hoisted_3, [
              _cache[4] || (_cache[4] = _createTextVNode(" Оператор: Национальная лига тренеров", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
              _cache[6] || (_cache[6] = _createTextVNode(" E-mail: ", -1)),
              _createElementVNode("a", {
                href: 'mailto:' + _ctx.contactEmail,
                class: "privacy-link"
              }, _toDisplayString(_ctx.contactEmail), 9, _hoisted_4)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}